import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initAnalytics, trackPageView, isAnalyticsEnabled } from '../lib/analytics'

interface PostHogProviderProps {
  children: React.ReactNode
}

// Initialize PostHog once on app load
let initialized = false

export function PostHogProvider({ children }: PostHogProviderProps) {
  const location = useLocation()

  // Initialize analytics on first render
  useEffect(() => {
    if (!initialized) {
      initAnalytics()
      initialized = true
    }
  }, [])

  // Track page views on route change
  useEffect(() => {
    if (isAnalyticsEnabled()) {
      // Small delay to ensure page title is updated
      const timeout = setTimeout(() => {
        trackPageView(window.location.href)
      }, 100)

      return () => clearTimeout(timeout)
    }
  }, [location.pathname, location.search])

  return <>{children}</>
}
